<template>
  <button
    @click="onClick"
    class="form-button"
    :class="{ 'disabled-button': disabled }"
    :disabled="disabled"
    :data-action="actionName"
  >
    <span v-if="!loading">
      <template>{{ text }}</template>
    </span>
    <span v-else>
      <LoadSpinner color="white" />
    </span>
  </button>
</template>

<script>
import LoadSpinner from '@/components/LoadSpinner'
export default {
  name: 'LoadingSpinnerButton',
  components: {
    LoadSpinner,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    actionName: {
      type: String,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';

.button {
  @include primary-button(var(--dark-brand-color));
}
.disabled-button {
  @include primary-button-disabled();
}
</style>
